export default __webpack_public_path__ + "static/media/W.2f1ed03a.png";